/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import {
  BuilderFormSchemaFactory,
  BuilderUserContext,
  FormRootSchema,
  FormState,
  FormStateSchema,
} from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';
import { whenEditMode } from '@gh/common-shared';
import { FormMode } from '@gh/core-ui';
import { SystemVarsEstimating } from '../../resources/model/system-vars-estimating.model';
import { SystemVarsEstimatingCommonSubTabFormState } from './system-vars-estimating-common-subtab/system-vars-estimating-common-subtab.form.service';
import { SystemVarsEstimatingOrderSubTabFormState } from './system-vars-estimating-orders-subtab/system-vars-estimating-orders-subtab.form.service';

@Injectable()
export class SystemVarsEstimatingTabFormState extends FormState<SystemVarsEstimating> {

  constructor(schemaFactory: BuilderFormSchemaFactory,
              private commonForm: SystemVarsEstimatingCommonSubTabFormState,
              private ordersForm: SystemVarsEstimatingOrderSubTabFormState,
              private userContext: BuilderUserContext) {
    super(schemaFactory);
  }

  build(details: SystemVarsEstimating): void {
    const mode = this.userContext.hasPermission(BuilderPermission.Setup.SystemVariables.Estimating.EDIT) ?
      FormMode.EditMode : FormMode.ViewMode;

    this.setMode(mode);

    this.commonForm.build(details.common, mode);
    this.ordersForm.build(details.orders, mode);

    this.initSchema(details);

    this.setChildForm('common', this.commonForm);
    this.setChildForm('orders', this.ordersForm);
  }

  protected buildSchema(value: SystemVarsEstimating, { root, native }: FormStateSchema): FormRootSchema {
    return root({
      enabled: whenEditMode(),
      mode: this.mode,
      optimisticLock: true,
      children: {
        id: void 0,
        common: native(this.commonForm.group),
        orders: native(this.ordersForm.group),
      },
    });
  }
}
